import { FeatureCollection, GeometryObject, MultiPolygon } from 'geojson';

export enum SheetFormat {
  Customize = 'customize',
  Template = 'template'
}

export enum Category {
  /** 町名 */
  Chome = '町名',
  /** 地区社協 */
  Chikushakyo = '地区社協',
  /** 包括支援 */
  Hokatsushien = '包括支援',
  /** 地区民児 */
  Chikuminjikyo = '地区民児協',
  /** 小学校 */
  ElementarySchool = '小学校',
  /** 中学校 */
  JuniorHighSchool = '中学校',
  /** 見守り */
  Mimamori = '見守り',
  /** 区 */
  Ku = '区'
}

export enum City {
  Nakahara = '川崎市中原区',
  Tama = '川崎市多摩区',
  Miyamae = '川崎市宮前区',
  Kawasaki = '川崎市川崎区',
  Saiwai = '川崎市幸区',
  Takatsu = '川崎市高津区',
  Aso = '川崎市麻生区'
}

export enum PopulationDataType {
  Household = '世帯数',
  Total = '総人口',
  Less15 = '年少人口',
  Age15_65 = '生産年齢人口',
  Over65 = '高齢者人口',
  Similarity = '類似地域',
  Support = '要支援、要介護(推計)'
  // ここに将来医療人口を加える？
  /*
  Over75 = '75歳以上',
  Over85 = '85歳以上',
  Male = '男総人口',
  Female = '女総人口',
  M0 = '男0～4歳',
  M5 = '男5～9歳',
  M10 = '男10～14歳',
  M15 = '男15～19歳',
  M20 = '男20～24歳',
  M25 = '男25～29歳',
  M30 = '男30～34歳',
  M35 = '男35～39歳',
  M40 = '男40～44歳',
  M45 = '男45～49歳',
  M50 = '男50～54歳',
  M55 = '男55～59歳',
  M60 = '男60～64歳',
  M65 = '男65～69歳',
  M70 = '男70～74歳',
  M75 = '男75～79歳',
  M80 = '男80～84歳',
  M85 = '男85～89歳',
  M90 = '男90～94歳',
  M95 = '男95～99歳',
  M100 = '男100歳以上',
  M_other = '男不詳',
  M_less15 = '男15歳未満',
  M_15_65 = '男15～64歳',
  M_over65 = '男65歳以上',
  M_over75 = '男75歳以上',
  M_over85 = '男85歳以上',
  F0 = '女0～4歳',
  F5 = '女5～9歳',
  F10 = '女10～14歳',
  F15 = '女15～19歳',
  F20 = '女20～24歳',
  F25 = '女25～29歳',
  F30 = '女30～34歳',
  F35 = '女35～39歳',
  F40 = '女40～44歳',
  F45 = '女45～49歳',
  F50 = '女50～54歳',
  F55 = '女55～59歳',
  F60 = '女60～64歳',
  F65 = '女65～69歳',
  F70 = '女70～74歳',
  F75 = '女75～79歳',
  F80 = '女80～84歳',
  F85 = '女85～89歳',
  F90 = '女90～94歳',
  F95 = '女95～99歳',
  F100 = '女100歳以上',
  F_other = '女不詳',
  F_less15 = '女15歳未満',
  F_15_65 = '女15～64歳',
  F_over65 = '女65歳以上',
  F_over75 = '女75歳以上',
  F_over85 = '女85歳以上'
  */
}

export enum CityDataType {
  Abuse2016 = '虐待数（2016）',
  Abuse2017 = '虐待数（2017）',
  PhysicallyHandicapped = '身体障害総数',
  IntellectualHandicapped = '知的障害総数',
  JoinCommunity = '町内会加入世帯（加入率）',
  NursingCare = '要介護認定者数'
}

export enum ValueType {
  Amount = 'amount',
  Proportion = 'proportion'
}

export enum Format {
  Map = 'map',
  LineChart = 'lineChart',
  BarChart = 'barChart',
  Similarity = 'similarity'
}

export enum POICategory {
  Ikoi = '特別養護老人ホーム_いこいの家',
  NursingHome = '特別養護老人ホーム',
  AreaConsultationSupport = '地域相談支援センター',
  AreaComprehensiveSupport = '地域包括支援センター',
  ChildCulture = 'こども文化センター',
  ChildCareSupport = '地域子育て支援センター',
  ChildConsultation = '児童相談所',
  Nursery = '保育園',
  ElementarySchool = '小学校',
  JuniorHighSchool = '中学校'
}

export enum SimilarityCategory {
  OldHousingArea = '高齢住宅地',
  ChildCareFamilyArea = 'ファミリー世帯',
  TowerMansionArea = 'タワマン',
  NormalHousingArea = '一般的な住宅地',
  SingleResidenceArea = '単身世帯',
  MansionDevelopingArea = '新興マンション、開発エリア',
  HousingDevelopingArea = '新興戸建開発エリア',
  nonHousingArea = '非居住エリア',
  lackData = 'データ不足'
}

export enum SupportCategoryType {
  supportNeed_1 = '要支援1',
  supportNeed_2 = '要支援2',
  lSupportNeed_1 = '要介護1',
  lSupportNeed_2 = '要介護2',
  lSupportNeed_3 = '要介護3',
  lSupportNeed_4 = '要介護4',
  lSupportNeed_5 = '要介護5'
}
export interface Karte {
  category: Category;
  city: City;
  area: string;
  populationDataType?: PopulationDataType;
  cityDataType?: CityDataType;
  valueType: ValueType;
  year?: number;
  format: Format;
  support: SupportCategoryType;
}

export interface Population {
  /** 合計人口 */
  total: number;
  /** 15歳未満の人口 */
  less15: number;
  /** 15-65歳の人口 */
  age15_65: number;
  /** 66歳以上の人口 */
  over65: number;
  /** 76歳以上の人口 */
  over75: number;
  /** 86歳以上の人口 */
  over85: number;
}

export interface DetailedPopulation extends Population {
  p0: number;
  p5: number;
  p10: number;
  p15: number;
  p20: number;
  p25: number;
  p30: number;
  p35: number;
  p40: number;
  p45: number;
  p50: number;
  p55: number;
  p60: number;
  p65: number;
  p70: number;
  p75: number;
  p80: number;
  p85: number;
  p90: number;
  p95: number;
  p100: number;
  other: number;
}
export interface Similarity {
  similarClusterIndex: number;
  similarAreaCategoryName: string;
  similarAreaSummaryText: string;
  similarAreaFeatureText: string;
  top3SimilarAreaName: string;
}

export interface SupportNeed {
  supportNeed_1: number;
  supportNeed_2: number;
  lSupportNeed_1: number;
  lSupportNeed_2: number;
  lSupportNeed_3: number;
  lSupportNeed_4: number;
  lSupportNeed_5: number;
}
export interface PopulationData {
  keyCode: string;
  prefName: string;
  cityName: string;
  areaName: string;
  dataType: string;
  year: number;
  month: number;
  /** 世帯数 */
  setai: number;
  /** 全員の人口データ */
  all: Population;
  /** 男性の人口データ */
  male: DetailedPopulation;
  /** 女性の人口データ */
  female: DetailedPopulation;
  // 類似度のデータ
  similarity: Similarity;
  // 将来医療人口のデータ
  support: SupportNeed;
}

export type Values = { [areaName: string]: number };

export type GeoDataProperties = {
  GST_NAME?: string;
  CSS_NAME?: string;
  area_name?: string;
};

export type GeoData = FeatureCollection<MultiPolygon, GeoDataProperties>;

export type GeoDataFeature = GeoData['features'] extends (infer T)[]
  ? T
  : never;

export type POIData = FeatureCollection<GeometryObject, POIProperty>;

export type POIProperty = {
  lat: number;
  lon: number;
  category: POICategory;
  name: string;
};

export type CityData = {
  [t in CityDataType]?: number;
} & {
  city: string;
};
